module.exports = __webpack_public_path__ + "assets/1b52aa4d2c4fa370036bdd70b502ab65.mp4";